<template>
    <div class="basic" style="height: calc(100% - 82px);" @click="hide">
        <div class="mainHead">
            <div class="route">
                <span class="crumbs"></span><span>监控中心</span>
            </div>
            <div> 
            </div>
        </div>
        <div class="fixedScorll" :style="{height: aa + 'px',}" >
            <div class="mains clearfix" >
                <div class="main_left" >
                    <div class="maindetails">
                        <div>
                            <div class="detailsName"> 

                                <!-- 集团 -->
                                <span  v-if="userType ==0" style="padding-right: 10px"><span v-if="textCenter==1">集团</span><span v-if="textCenter==2">校企</span>名称：</span>
                                <!-- 校企 -->
                                <span v-if="userType !=0" style="padding-right: 10px">校企名称：</span>

                                <span>{{getMessageInfoData.customerName}}</span>
                            
                            </div>
                            <div class="detailsDevice">
                                <span style="padding-right: 10px">监测点数：</span><span><span></span>{{getMessageInfoData.enabled}} (启用)<span style="margin:0 10px;">|</span>{{getMessageInfoData.unEnabled}} (禁用)</span> 
                            </div>
                        </div>

                        <div class="detailAddressW">
                          <div class="detailAddress" style="display:flex;">
                               <!-- 集团 -->
                              <span  v-if="userType ==0" class="" style="padding-right: 10px;width:80px;"><span v-if="textCenter==1">集团</span><span v-if="textCenter==2">校企</span>地址：</span>
                               <!-- 校企 -->
                              <span  v-if="userType !=0" class="" style="padding-right: 10px;width:80px;">校企地址：</span>
                                <span class="spanAddress" style="display: inline-block;cursor:pointer;">
                                  <span v-if="addressAWidth"><span v-html="getMessageInfoData.address"></span> <span v-if="getMessageInfoData.address"  style="display:inline-block;margin:0 10px;"><span v-if="getMessageInfoData.detailAddress">|</span></span>{{getMessageInfoData.detailAddress}}</span>
                                  <el-tooltip v-if="!addressAWidth" class="item" effect="dark" :content="getMessageInfoData.addressA" placement="bottom-start">
                                      <span><span v-html="getMessageInfoData.address"></span> <span v-if="getMessageInfoData.address"  style="display:inline-block;margin:0 10px;"><span v-if="getMessageInfoData.detailAddress">|</span></span>{{getMessageInfoData.detailAddress}}</span>
                                  </el-tooltip>
                                </span> 
                          </div>
                          <div class="detailAddress">     
                                 <!-- 集团 -->                 
                              <span v-if="userType ==0"  style="padding-right: 10px;margin-left:0px; "><span v-if="textCenter==1">校企</span><span v-if="textCenter==2">建筑</span>数量：</span>
                               <!-- 校企 -->
                              <span v-if="userType !=0"  style="padding-right: 10px;margin-left:0px; ">建筑数量：</span><span >{{getMessageInfoData.num}}</span>
                          </div>
                        </div>
                        <div class="iconImg">
                          <div class="iconImgP">
                            <img src="../../assets/img/Supervise1.png" alt="">
                            <span :class="{'circle':getMessageInfoData.normal=='','circleNone':getMessageInfoData.normal=='zero'}">{{getMessageInfoData.normal}}</span>
                            <p>正常</p>
                          </div>
                          <div class="iconImgP">
                            <img src="../../assets/img/Supervise2.png" alt="">
                            <span :class="{'circle':getMessageInfoData.warning=='','circleNone':getMessageInfoData.warning=='zero'}">{{getMessageInfoData.warning}}</span>
                            <p>告警</p>
                          </div>
                          <div class="iconImgP">
                            <img src="../../assets/img/Supervise3.png" alt="">
                            <span :class="{'circle':getMessageInfoData.earlyWarning=='','circleNone':getMessageInfoData.earlyWarning=='zero'}">{{getMessageInfoData.earlyWarning}}</span>
                            <p>预警</p>
                          </div>
                          <div class="iconImgP">
                            <img src="../../assets/img/Supervise4.png" alt="">
                            <span :class="{'circle': getMessageInfoData.leave=='','circleNone':getMessageInfoData.leave=='zero'}">{{getMessageInfoData.leave}}</span>
                            <p>离线</p>
                          </div>
                        </div>
                    </div>
                    <div class="No" v-show="pageListData.length==0">
                        <img src="../../../static/img/Nodata.png">
                        <span>暂无数据</span>
                    </div>
                    <div class="SuperviseList_W">

                      <div class="List_Children" v-show="pageListData.length!=0" v-for="(item,index) in pageListData" :key="index">
                        <div class="ListTop">
                          <img  :src="item.imgSrc" alt="">
                          <span>{{item.typeName}}设备</span>
                          <span>启用：{{item.enabled}} | 禁用：{{item.unEnabled}}</span>
                        </div>
                        <div class="ListCenter">
                          <div class="ListCenterLeft monitor">
                            <ul>
                              <li>
                                  <span>正常</span>
                                  <el-progress class="pullleft" :percentage="item.normal" :show-text="false" :stroke-width="7"></el-progress>
                                  <span class="pull-right" style="color:#198cff">{{item.normal}}</span>
                              </li>
                              <li>
                                  <span>告警</span>
                                  <el-progress class="pullleft" :percentage="item.warning" :show-text="false" :stroke-width="7"></el-progress>
                                  <span class="pull-right" style="color:#198cff">{{item.warning}}</span>
                              </li>
                              <li v-if="item.type == 1||item.type == 2||item.type == 3||item.type == 6">
                                  <span>预警</span>
                                  <el-progress class="pullleft" :percentage="item.earlyWarning" :show-text="false" :stroke-width="7"></el-progress>
                                  <span class="pull-right" style="color:#198cff">{{item.earlyWarning}}</span>
                              </li>
                              <li>
                                  <span>离线</span>
                                  <el-progress class="pullleft" :percentage="item.leave" :show-text="false" :stroke-width="7"></el-progress>
                                  <span class="pull-right" style="color:#198cff">{{item.leave}}</span>
                              </li>
                            </ul>
                          </div>
                          <div class="ListCenterRight">
                              <div :id="item.imgSrcId" class="chart"></div>
                          </div>
                        </div>
                        <!-- <div class="ListBottomSky" v-if="item.alarmInfos.length==0">
                          <span>暂无告警消息</span>
                        </div>
                        <div class="ListBottom" v-else>
                          <img src="../../assets/img/tag2.png" alt="">
                          <span>{{item.alarmInfos[0].createTime}}</span>
                          <span><span style="color:#f98d00">[{{item.alarmInfos[0].name}}]</span>监测点<span style="color:#f98d00">[{{item.alarmInfos[0].name1}}]</span></span>
                          <span @click.stop="alarmStop(index,item.type)">更多>></span>
                          <div class="popoverW"  v-if="alarm==index+1">
                            <div class="popoverList" v-for="(item,index) in alarmInfosArr"  :key="index">
                              <span> <span style="color:#282828">[</span><span :class="item.type==0?'textClore0':item.type==1?'textClore1':'textClore2'">{{item.name1}}</span><span  style="color:#282828">]</span></span>
                              <span>{{item.name}}</span>
                              <span>{{item.createTime}}</span>
                            </div>
                          </div>
                          <div style="clear:both"></div>
                        </div> -->

                      </div>

                      
                    </div>

                    
            
                </div>
                
            </div>
        </div>
    </div>

  



</template>
<script>
    import todoList from "@/components/todoList";
    import echarts from 'echarts';
    import {ajaxFuncJson} from '@/api/ajax';
    require('echarts/theme/macarons'); // echarts theme
    export default {
        name: 'monitorDetails',
        components: {
            todoList
        },
        inject:['reload'],
        data () {
            return {
              aa:'',  //屏幕可视区的高度
              alarm:'',//更多
                msg: '监控中心',
              
                btnS: true,
                dataList:[  //实时报警处理情况数据
                    {value:0, name:'待处理'},
                    {value:0, name:'处理中'},
                    {value:0, name:'审核中'},
                ],
                userType:sessionStorage.getItem("userType"),//判断1是校企  0是集团
                isShowDot:false,
                windowResize:null,
                dealArr: [3380, 16, 218],
                getMessageInfoData:'',//列表查询汇总信息，头部
                getMonitoringMessageInfoData:'',//头部数据
                pageListData:'',//列表数据
                getAlarmInfoId:'',//请求列表的ID
                textCenter:1,//判断是校企还是建筑

                alarmInfosArr:[],//判断是校企还是建筑
                addressAWidth:true,//判断地址是否超出需要鼠标移上效果

            }
        },
        created() {

          if(sessionStorage.getItem('userType')!=0&&sessionStorage.getItem('userType')!=5){
            // 校企端
              this.getAlarmInfoId = sessionStorage.getItem('menuS');
              let parms = {
                  id: sessionStorage.getItem('menuS'),
              }  
              this.getMessageInfo(parms)
              let parms1 = {
                  id: sessionStorage.getItem('menuS'),
              } 

              this.alarm = '';//更多清空处理
              this.getMonitoringMessageInfo(parms1)
              return;
          }



          if(this.$store.state.leftMonitorInfo&&sessionStorage.getItem('menuS')){
            // 判断页面刷新选中的是一级菜单
            this.textCenter = 1;
            if(this.$store.state.leftMonitorInfo[0].id==sessionStorage.getItem('menuS')){
              this.getAlarmInfoId = '';
              let parms = {
                  id: '',
              }  
              this.getMessageInfo(parms)
              let parms1 = {
                  id: '',
              } 

              this.alarm = '';//更多清空处理
              this.getMonitoringMessageInfo(parms1)
            }else{
              //判断页面刷新选中的是二级级菜单值
              this.textCenter = 2;
              this.getAlarmInfoId = sessionStorage.getItem('menuS');
              let parms = {
                  id: sessionStorage.getItem('menuS'),
              }  
              this.getMessageInfo(parms)
              let parms1 = {
                  id: sessionStorage.getItem('menuS'),
              } 
              this.alarm = '';//更多清空处理
              this.getMonitoringMessageInfo(parms1)
            }

          }else{
              // 判断页面刷新选中的是一级菜单
              this.textCenter = 1;
            this.getAlarmInfoId = '';
              let parms = {
                  id: '',
              }  
              this.getMessageInfo(parms)
              let parms1 = {
                  id: '',
              } 
               this.alarm = '';//更多清空处理
              this.getMonitoringMessageInfo(parms1)

          }



        },
        computed:{
            getMap() {
                return this.$store.state.buildingId
            },
            handleOpen(){
                return this.$store.state.menuS
            },
        },
        watch: {
          handleOpen(newV, oldV) { // status的变化，然后执行操作
              if(sessionStorage.getItem('userType')!=0){
                // 校企端
                this.getAlarmInfoId = sessionStorage.getItem('menuS');
                  let parms = {
                      id: sessionStorage.getItem('menuS'),
                  }  
                  // this.getMessageInfo(parms)
                  let parms1 = {
                      id: sessionStorage.getItem('menuS'),
                  } 

                  this.alarm = '';//更多清空处理
                  // this.getMonitoringMessageInfo(parms1)
                  return;
              }
              // 判断页面选中的是一级菜单值
                if(this.$store.state.leftMonitorInfo[0].id==newV){
                  this.textCenter = 1;
                  this.getAlarmInfoId = ''
                  let parms = {
                    id: '',
                  }  
                  // this.getMessageInfo(parms)
                  let parms1 = {
                    id: '',
                  } 
                  this.alarm = '';//更多清空处理
                  // this.getMonitoringMessageInfo(parms1)
                }
          },
          getMap(newV, oldV) { // status的变化，然后执行操作
              if(sessionStorage.getItem('userType')!=0){
                // 校企端
                this.getAlarmInfoId =sessionStorage.getItem('menuS');
                  let parms = {
                      id: sessionStorage.getItem('menuS'),
                  }  
                  this.getMessageInfo(parms)
                  let parms1 = {
                      id: sessionStorage.getItem('menuS'),
                  } 

                  this.alarm = '';//更多清空处理
                  this.getMonitoringMessageInfo(parms1)
                  return;
              }
              // 判断页面选中的是一级菜单值
              if(this.$store.state.leftMonitorInfo[0].id==newV){
                this.textCenter = 1;
                this.getAlarmInfoId = ''
                  let parms = {
                    id: '',
                  }  
                  this.getMessageInfo(parms)
                  let parms1 = {
                    id: '',
                  }
                   this.alarm = '';//更多清空处理 
                  this.getMonitoringMessageInfo(parms1)
              }else{
                // 判断页面选中的是二级菜单值
                this.textCenter = 2;
                this.getAlarmInfoId = newV;
                  let parms = {
                    id: newV,
                  }  
                  this.getMessageInfo(parms)
                  let parms1 = {
                    id: newV,
                  } 
                   this.alarm = '';//更多清空处理
                  this.getMonitoringMessageInfo(parms1)
              }
          },
           
           
        },
        methods:{
          mapBtn() {
            sessionStorage.setItem('router','mapIndexHome')
            this.$store.state.bigScreenBuildingId='';
            this.$router.push({path:'/mapIndexHome'})
          },
          hide(){
            var than = this;
            than.alarm = ''
          },
        
          // 实时报警处理情况图表
          histogram(obj) {
              const _dataList=this.dataList;
              this.hisChart = echarts.init(obj);
              this.hisChart.setOption({
                tooltip: {
                    trigger: 'item',
                    formatter: "{a} <br/>{b}: {c} ({d}%)",
                    textStyle:{
                      fontSize:13,
                      color:['#66b3ff'],
                    },
                    backgroundColor: ['rgba(0,0,0,.6)'], 
                    padding: 10,
                },
                color:['#06d0b3','#00a0f5','#fc6900',],
                legend: {
                    orient: 'vertical',
                    x: 'left',
                    data:this.dataList.name,
                    y:'center',
                    left: '16%',
                    bottom: '23%',
                    icon:'rect',
                    itemWidth:10,
                    itemHeight:10,
                    formatter:function(name){
                        let target;
                        for(let i = 0;i <_dataList.length; i++){
                            if(_dataList[i].name === name){
                                target = _dataList[i].value
                            }
                        }
                        let arr = ["{a|"+name+' :'+"}","{b|"+target+"}"];
                        return arr.join("    ")
                    },
                    textStyle:{
                        fontSize:13,
                        lineHeight:20,
                        rich: {
                            a: {
                                color: '#282828',
                            },
                            b: {
                                color: '#282828',    
                            }
                        } 
                    },
                },
                series: [
                    {
                        name:'实时报警处理情况',
                        type:'pie',
                        radius: ['30%', '40%'],
                        center: ['70%', '50%'],
                        avoidLabelOverlap: false,
                        label: {
                            normal: {
                                show: false,
                                position: 'center'
                            },
                            emphasis: {
                                show: false
                            }
                        },
                        labelLine: {
                            normal: {
                                show: false
                            }
                        },
                        data:this.dataList,
                    }
                ]                  
              });
          },  

          getMessageInfo(parms){ //列表查询汇总信息，头部
                    
            ajaxFuncJson('/enterprise/getMessageInfo',parms).then(res=>{
                if(res.data.status == 200){
                    if(res.data.data.normal==1){
                      res.data.data.normal = '';
                    }else if(res.data.data.normal==0){
                      res.data.data.normal = 'zero';
                    }else if(res.data.data.normal>99){
                      res.data.data.normal = '99+';
                    }
                    if(res.data.data.warning==1){
                      res.data.data.warning = '';
                    }else if(res.data.data.warning==0){
                      res.data.data.warning = 'zero';
                    }else if(res.data.data.warning>99){
                      res.data.data.warning = '99+';
                    }
                    if(res.data.data.earlyWarning==1){
                      res.data.data.earlyWarning = '';
                    }else if(res.data.data.earlyWarning==0){
                      res.data.data.earlyWarning = 'zero';
                    }else if(res.data.data.earlyWarning>99){
                      res.data.data.earlyWarning = '99+';
                    }
                    if(res.data.data.leave == 1){
                      res.data.data.leave = '';
                    }else if(res.data.data.leave==0){
                      res.data.data.leave = 'zero';
                    }else if(res.data.data.leave>99){
                      res.data.data.leave = '99+';
                    }
                    this.getMessageInfoData = res.data.data;
                    if(this.getMessageInfoData.address){
                      this.getMessageInfoData.addressA = this.getMessageInfoData.address+this.getMessageInfoData.detailAddress;
                      this.getMessageInfoData.address = (this.getMessageInfoData.address).replace(/\|/g, "<span style='margin:0 10px'>|</span>") 
                      // if(this.textSize("14px","Arial",this.getMessageInfoData.addressA).width+20*this.getMessageInfoData.address.match(eval("/margin/ig")).length+20>=300){
                        this.addressAWidth = false;
                      // }else{
                        // this.addressAWidth = true;
                      // }
                    }else{
                      this.getMessageInfoData.addressA = this.getMessageInfoData.detailAddress;
                      if(this.textSize("14px","Arial",this.getMessageInfoData.addressA).width >=300){
                        this.addressAWidth = false;
                      }else{
                        this.addressAWidth = true;
                      }
                    }


                }else{
                   this.$message.error(res.data.msg);
                }
            })
          },

          textSize(fontSize,fontFamily,text){
            var span = document.createElement("span");
            var result = {};
            result.width = span.offsetWidth;
            result.height = span.offsetHeight;
            span.style.visibility = "hidden";
            span.style.fontSize = fontSize;
            span.style.fontFamily = fontFamily;
            span.style.display = "inline-block";
            document.body.appendChild(span);
            if(typeof span.textContent != "undefined"){
              span.textContent = text;
            }else{
              span.innerText = text;
            }
            result.width = parseFloat(window.getComputedStyle(span).width) - result.width;
            result.height = parseFloat(window.getComputedStyle(span).height) - result.height;
            return result;
          },
          alarmStop(obj,obj1){
            var than = this;
            let parms = {
                id: this.getAlarmInfoId,//监管id
                type:obj1
            } 
            // this.getAlarmInfo(parms);
          },

          getMonitoringMessageInfo(parms){ //各设备详情
            ajaxFuncJson('/enterprise/getMonitoringMessageInfo',parms).then(res=>{
                if(res.data.status == 200){
                    this.getMonitoringMessageInfoData = res.data.data;
                    if(this.getMonitoringMessageInfoData.length>0){
                      this.getMonitoringMessageInfoData.forEach(function(item,index){
                        // 1电气 2水压 3液位 4可燃气 5烟感 6灭火器 7水浸'用传'
                        if(item.type==1){
                          item.typeName = '电气';
                          item.imgSrc = require('../../assets/img/typeIcon1.png');
                        }else if(item.type==2){
                          item.typeName = '水压';
                          item.imgSrc = require('../../assets/img/typeIcon2.png');
                        }else if(item.type==3){
                          item.typeName = '液位';
                          item.imgSrc = require('../../assets/img/typeIcon3.png');
                        }else if(item.type==4){
                          item.typeName = '可燃气';
                          item.imgSrc = require('../../assets/img/typeIcon4.png');
                        }else if(item.type==5){
                          item.typeName = '烟感';
                          item.imgSrc = require('../../assets/img/typeIcon5.png');
                        }else if(item.type==6){
                          item.typeName = '灭火器';
                          item.imgSrc = require('../../assets/img/typeIcon6.png');
                        }else if(item.type==7){
                          item.typeName = '水浸';
                          item.imgSrc = require('../../assets/img/typeIcon7.png');
                        }else if(item.type==8){
                          item.typeName = '用传';
                          item.imgSrc = require('../../assets/img/typeIcon8.png');
                        }
                        item.imgSrcId = 'imgSrcId'+index;//动态id
                        item.btnMess = 1;//弹出层
                        // item.dataList = [ 
                        //   {value:item.toBeProcessed, name:'待处理'},
                        //   {value:item.processing, name:'处理中'},
                        //   {value:item.auditInProgress, name:'审核中'},
                        // ];//图表
                        // if(item.alarmInfos.length>0){
                        //   item.alarmInfos.forEach(function(item1,index){
                        //     if(item1.type == 0 ){
                        //       item1.name1 = '告警'
                        //     }else if(item1.type == 1 ){
                        //       item1.name1 = '离线'
                        //     }else if(item1.type == 2 ){
                        //       item1.name1 = '故障'
                        //     }
                        //   })

                        // }
                        
                      })
                        this.pageListData =  this.getMonitoringMessageInfoData
                        this.man(parms); //响应图表
                      // this.read(this.getMonitoringMessageInfoData).then(()=>{
                      //   this.pageListData.forEach((item,index)=>{
                      //     this.dataList = item.dataList
                      //       this.histogram(document.getElementById('imgSrcId'+index))
                      //   })   
                      // }); 
                    }
                    
                }else{
                   this.$message.error(res.data.msg);
                }
            })
          },
          // 统计分析
          man(parms){
            ajaxFuncJson('/enterprise/getMonitoringStatus',parms).then(res=>{
                if(res.data.status == 200){
                  var list = [];
                    list = res.data.data;
                    // if(list.length>0){
                                                                
                                          this.getMonitoringMessageInfoData.forEach((a,b)=>{
                                                    a.dataList = [ 
                                                      {value:0, name:'待处理'},
                                                      {value:0, name:'处理中'},
                                                      {value:0, name:'审核中'},
                                                    ];//图表
                                                    if(list.length>0){
                                                      list.forEach((item,index)=>{
                                                        if(a.type == item.type){
                                                          a.dataList = [ 
                                                            {value:item.toBeProcessed, name:'待处理'},
                                                        {value:item.processing, name:'处理中'},
                                                        {value:item.auditInProgress, name:'审核中'},
                                                      ];//图表
                                                    }
                                                  })
                                                    }

                                          })

                                                            this.read(this.getMonitoringMessageInfoData).then(()=>{
                                                                  this.pageListData.forEach((item,index)=>{
                                                                    this.dataList = item.dataList
                                                                      this.histogram(document.getElementById('imgSrcId'+index))
                                                                  })   
                                                                }); 

                // }
                    
                }else{
                   this.$message.error(res.data.msg);
                }
            })
          },



          getAlarmInfo(parms){ //查询各设备通知
            let than = this;     
            ajaxFuncJson('/enterprise/getAlarmInfo',parms).then(res=>{
                if(res.data.status == 200){
                  res.data.data[0].alarmInfos.forEach((item,index)=>{
                     if(item.type == 0 ){
                        item.name1 = '告警'
                      }else if(item.type == 1 ){
                        item.name1 = '离线'
                      }else if(item.type == 2 ){
                        item.name1 = '故障'
                      }
                  })
                  this.alarmInfosArr = res.data.data[0].alarmInfos;
                  this.alarm = parms.type;

                }else{
                   this.$message.error(res.data.msg);
                }
            })
          },
          // 回调循环图表
          read(content) {
            var than = this;
            return new Promise(function( reslove,reject ) {
                than.pageListData = content;
                reslove('成功')
            })
          },
           
        },



        mounted() {
            //获取屏幕宽高；子组件高度自适应
            let that = this;
            that.windowResize= function () {
                that.aa= document.body.clientHeight-130;
                // that.isScroll();
            };
            that.windowResize();
            window.addEventListener('resize',that.windowResize);
            },
            destroyed(){

        }
    }
</script>
<style scoped lang="scss">
    @import "@/assets/css/mixin.scss";
    .mains {
        display: flex;
        position: relative;
    }
    .textClore0{
      color:#f55353;
    }
    .textClore1{
      color:#607d8b;
    }
    .textClore2{
      color:#fb8c00;

    }
    .No{
        top: 309px;
    }
    .circle{
      padding: 4px !important;
    }
    .circleNone{
      display: none;
    }
    .btns {
        li {
            float: left;
            @include wh(80px,30px);
            margin-top: 5px;
            text-align: center;
            line-height: 30px;
            font-size: $fontSizeTwo;
            outline: 1px solid #e0e0e0;
            outline-offset: -1px;
            &:nth-child(1):hover {
                color: #198cff;
                outline: 1px solid #198cff;
                cursor: pointer;
            }
            &:nth-child(2):hover {
                background-color: #3399ff;
            }
        }
        .btn_select1 {
            color: #fff;
            background-color: #198cff;
            outline: none;
        }
    }
    .main_left {
        flex: 1;
    }
    .detailAddressW{
      display: flex;
    }
    .spanAddress{
      width: 310px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      
    }
    .spanAddress a{
        width: 310px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    .el-main .maindetails{
        position: relative;
        padding: 30px 40px;
        margin-top: 10px;
        height: 118px;
        margin-right: 1.05%;
        background-color: #fff;
        font-size: $fontSizeThree;
        line-height: 14px;
        color: #282828;
        &>div:first-child {
            width: 800px;
            @include flexible;
            .detailsName{
                height: 15px;
                width: 420px;
            }
            
            .detailsName>span:last-child{
                display: inline-block;
                width: 260px;
                vertical-align: middle;
                @include textOverflow
            }
            .detailsDevice{
                height: 15px;
                line-height: 15px;
                margin-left: 0;
            }
        }
        .detailAddress{
            height: 15px;
            line-height: 15px;
            margin-top: 30px;
            width: 420px;
            // display: inline-block;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
    }
    .iconImg{
      height: 78px;
      width: 40%;
      max-width: 380px;
      position: absolute;
      top: 20px;
      right: 0;
      overflow: hidden;
      .iconImgP{
        height: 100%;
        width: 70px;
        float: left;
        margin-left: 20px;
        position: relative;
      }
      .iconImgP>img{
        width: 50px;
        display: block;
         margin: auto;
      }
      .iconImgP> p{
        font-size: 13px;
        line-height: 25px;
        text-align: center;
        
      }
      .iconImgP> span{
        color: #fff;
        position: absolute;
        top: 0;
        left: 52px;
        padding: 2px 5.5px;
        background: red;
        border-radius: 16px;
        font-size: 10px;
      }
      
    }

    .SuperviseList_W{
      margin-right: 1.05%;
      font-size: $fontSizeThree;
      line-height: 14px;
      color: #282828;
      overflow: hidden;
      padding-bottom: 20px;
      .List_Children:nth-child(even){
        margin-left: 1.4%;
      }
      .List_Children{
        margin-top: 10px;
        float: left;
        width: 49.3%;
        padding: 10px 20px 0px 20px;
        background: #fff;
        .ListTop{
          border-bottom: 1px solid #f4f4f4;
          padding-bottom:10px; 
          overflow: hidden;
        }
        .ListTop>img{
          width: 60px;  
          float: left; 
        }
        .ListTop>span:nth-of-type(1){
          display: inline-block;
          line-height: 60px;
          float: left;
          margin-left: 10px;
          font-size: $fontSizeFive;
          font-weight: bold;
        }
        .ListTop>span:nth-of-type(2){
          display: inline-block;
          line-height: 60px;
          margin-left: 30px;
          float: left;
        }

        .ListBottom{
          // overflow: hidden;
          padding: 10px 0;
          position: relative;
        }
        .ListBottomSky{
          padding: 10px 0;
          position: relative;
          line-height: 20px;
        }
        .ListBottom>img{
          width: 16px;  
          float: left;
        }
        .ListBottom>span:nth-of-type(1){
          display: inline-block;
          float: left;
          line-height: 20px;
          margin-left: 10px;
        }
        .ListBottom>span:nth-of-type(2){
          display: inline-block;
          margin-left: 30px;
          line-height: 20px;
          float: left;
        }
        .ListBottom>p{
          display: inline-block;
          margin-left: 30px;
          line-height: 20px;
          float: right;
        }
       .ListBottom>span:nth-of-type(3){
          display: inline-block;
          margin-left: 30px;
          line-height: 20px;
          float: right; 
          cursor: pointer;  

        }

      .ListBottom>.popoverW::-webkit-scrollbar {/*滚动条整体样式*/
        width: 4px;     /*高宽分别对应横竖滚动条的尺寸*/
        height: 1px;
      }
      .ListBottom>.popoverW::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
        border-radius: 2px;
        -webkit-box-shadow: inset 0 0 5px #999;
        background: #535353;
      }
      .ListBottom>.popoverW::-webkit-scrollbar-track {/*滚动条里面轨道*/
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        border-radius: 10px;
        background: #EDEDED;
      }




        .ListBottom>.popoverW{
          padding: 30px 20px 20px 20px;
          position: absolute;
          right: 0;
          bottom: 50px;
          width: 520px;
          max-height:280px;
          overflow-y: auto; 
          background: #fff;
          border: 1px solid #cce5ff;
          box-shadow: 0 2px 12px 0 rgba(25,140,255,0.3); 
          .popoverList{
            widows: 100%;
            overflow: hidden;
            padding-bottom: 20px;
            font-size: $fontSizeTwo;
          }
          .popoverList>span:nth-of-type(1){
              display: inline-block;
              line-height: 20px;
              float: left;
          }
          .popoverList>span:nth-of-type(2){
              display: inline-block;
              line-height: 20px;
              float: left;
              margin-left: 35px;
              width: 240px;
              overflow: hidden;
              text-overflow:ellipsis;
              white-space: nowrap;
              color: #282828;
          }
          .popoverList>span:nth-of-type(3){
              display: inline-block;
              line-height: 20px;
              color: #666666;
              float: right;
              cursor: default;
          }
        }


        .ListCenter{
          padding: 9px 15px;
          overflow: hidden;
          border-bottom: 1px solid #f4f4f4;
        }
        .ListCenter>.ListCenterLeft{
          float: left;
          width: 50%;
          border-right: 1px solid #f4f4f4;
          font-size: 13px;
        }
        .ListCenter>.ListCenterRight{
          float: left;
          width: 50%;
        }


      }
    }
      .monitor ul{
        display: block;
        height: 200px;
        
      }
    .monitor li {
        height: 50px;
        @include flexible;
        @include alignItems(center);
        span {
            float: left;
            line-height: 55px;
            padding-right: 10px;
        }
    }
    .el-progress {
        float: left;
        width: 70%;
        @include flexible;
        @include alignItems(center);
    }
    .chart{
        width: 100%;
        height: 180px;
      }
      .all_inner {
          position: relative;
          span {
              color: #f5f5f5;
          }
      }
      @media screen and (max-width: 1366px) {
        .chart{
          height: 156px;
        }
      }
    
  
</style>



// WEBPACK FOOTER //
// src/page/MonitoringSupervise/index.vue